import axios from "../axios";
import { bannerCardsURL } from "../requests";
export const deleteBannerCardApi = (token: string, banner_card_id: string) => {
  return axios.delete(bannerCardsURL + `/${banner_card_id}`, {
    headers: { token },
  });
};
